import React from "react";

export function PurchaseRequisitionPage() {
  return <div></div>;
}
